var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"priceAll"},[_c('div',{staticClass:"priceAll__txt"},[_vm._v("お支払い総計 (税込)")]),_c('div',{staticClass:"priceAll__price"},[_vm._v(_vm._s(_vm.amount.toLocaleString())+"円")])])
}
var staticRenderFns = []

export { render, staticRenderFns }